import * as wipDB from 'Services/wipdb.json';
import config from '../../../config/config';

const experienceAPIURL = `${config.experienceAPIURL}/api/v1`;



const acHTTPClient = {
    request: () => {
        return Promise.resolve({ data: { data: [] } });
    },
};

export async function getUsers() {
    let apiURL = `${experienceAPIURL}/users`;
    const request = { url: apiURL, method: 'GET' };
    return await acHTTPClient.request(request).then((response) => {
        return response.data?.data || [];
    });
}

export async function getMicroExperienceTags() {
    return new Promise((resolve, reject) => {
        resolve(wipDB.Tags);
    });
}

export async function getSparks() {
    let apiURL = `${experienceAPIURL}/sparks`;
    const request = { url: apiURL, method: 'GET' };
    return await acHTTPClient.request(request).then((response) => {
        return response.data?.data || [];
    });
}

export async function getPublicDates(customerId) {
    return new Promise((resolve, reject) => {
        resolve(wipDB.PublicDates);
    });
}

export const Lookups = {
    Status: [
        { code: 'ACTIVE', display: 'Active' },
        { code: 'INACTIVE', display: 'Inactive' },
        { code: 'ARCHIVED', display: 'Archived' },
    ],
    EffortValue: [
        { code: 'TIMEFILLER', display: 'Time Filler' },
        { code: 'MILESTONE', display: 'Milestone' },
    ],
    EffortSize: [
        { code: 'XS', display: 'Extra Small' },
        { code: 'S', display: 'Small' },
        { code: 'M', display: 'Medium' },
        { code: 'L', display: 'Large' },
        { code: 'XL', display: 'Extra Large' },
    ],
    RequiredItems: [
        { code: 'HOUSEHOLD', diplay: 'Household' },
        { code: 'STOREBOUGHT', display: 'Store Bought' },
        { code: 'NONE', display: 'None' },
    ],
    contentTypeDef: [
        { code: 'SPARK', display: 'Spark' },
        { code: 'LINK', display: 'Link' },
        { code: 'MANUAL', display: 'Manual' },
    ],

    countryList: [
        { code: 'GLOBAL', display: 'Global' },
        { code: 'AU', display: 'Australia' },
        { code: 'US', display: 'UnitedStates' },
        { code: 'NZ', display: 'New Zealand' },
        { code: 'UK', display: 'United Kingdom' },
    ],

    participantsList: [
        { code: 'ANY', display: 'Any' },
        { code: 'PARTNER', display: 'With Partner' },
        { code: 'FRIENDS', display: 'With Friends' },
        { code: 'FAMILY', display: 'With Family' },
        { code: 'SOLO', display: 'Solo' },
    ],

    deliveryType: [
        { code: 'DIGITAL', display: 'Digital' },
        { code: 'PHYSICAL', display: 'Physical Kit' },
    ],
};
